import axios from "axios";
import {url_local} from '../url'
import state from '../../store/index'

export function login(form) {

const config = {
    header : {
        'Content-Type' : 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    }
}

  return new Promise((res, rej) => {
    axios.post(`${url_local}auth/login`, form, config).then(response => {
        res(response.data);
      })
      .catch(err => {
        rej(err.message);
      });
  });
}

export function editStatusUser(id,form) {

  const config = {
    headers : {
        'Content-Type' : 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
         Authorization: "Bearer " +state.state.currentUser.access_token
    }
}
  
    return new Promise((res, rej) => {
      axios.put(`${url_local}user_status/${id}`, form, config).then(response => {
          res(response.data);
        })
        .catch(err => {
          rej(err);
        });
    });
  }

  export function editStatusAppUser(id,form) {

    const config = {
      headers : {
          'Content-Type' : 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
           Authorization: "Bearer " +state.state.currentUser.access_token
      }
  }
    
      return new Promise((res, rej) => {
        axios.put(`${url_local}user_status_app/${id}`, form, config).then(response => {
            res(response.data);
          })
          .catch(err => {
            rej(err);
          });
      });
    }


export function GetUserSupervisor() {

  const config = {
    headers : {
        'Content-Type' : 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
         Authorization: "Bearer " +state.state.currentUser.access_token
    }
}
    //console.log(config);
    return new Promise((res, rej) => {
      axios.get(`${url_local}user`, config).then(response => {
          res(response.data);
        })
        .catch(err => {
          rej(err);
        });
    });
  }

  export function GetUserApp() {

    const config = {
      headers : {
          'Content-Type' : 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
           Authorization: "Bearer " +state.state.currentUser.access_token
      }
  }
      //console.log(config);
      return new Promise((res, rej) => {
        axios.get(`${url_local}user_aplicacion`, config).then(response => {
            res(response.data);
          })
          .catch(err => {
            rej(err);
          });
      });
    }

    export function GetUserAppSupervisor(id){

      const config = {
        headers : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
             Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }
        //console.log(config);
        return new Promise((res, rej) => {
          axios.get(`${url_local}user_aplicacion_supervisor/${id}` , config).then(response => {
              res(response.data);
            })
            .catch(err => {
              rej(err);
            });
        });
      

    }

  



export function register(form) {

  const config = {
      header : {
          'Content-Type' : 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
      }
  }
  
    return new Promise((res, rej) => {
      axios.post(`${url_local}auth/signup`, form, config).then(response => {
          res(response.data);
        })
        .catch(err => {
          rej(err);
        });
    });
  }

  export function registerApp(form) {

    const config = {
        header : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    }
    
      return new Promise((res, rej) => {
        axios.post(`${url_local}auth/signupApp`, form, config).then(response => {
            res(response.data);
          })
          .catch(err => {
            rej(err);
          });
      });
    }


export function getLocalUser() {
  const userStr = localStorage.getItem("user");

  if (!userStr) {
    return null;
  }

  return JSON.parse(userStr);
}
